import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import { Loader, OnboardingWrapper } from '../../shared/components';
import { Clinic } from '../../shared/types';

type ViewProps = {
  isLoading: boolean;
  email: string;
  clinic: Clinic;
  login: () => void;
  requestDynamicLink: () => void;
};

const useStyles = makeStyles((theme) => ({
  header: {
    fontSize: '19px',
    fontWeight: 600,
    lineHeight: '28.5px',
    letterSpacing: '0.03px',
    marginBottom: '10px',
    color: theme.palette.primary.main,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  textFieldsWrapper: {
    padding: '0 15px',
  },
  confirmationParagraph: {
    fontSize: '15px',
    marginBottom: '25px',
    color: theme.palette.text.secondary,
  },
  textField: {
    marginBottom: '10px',
    width: '100%',
    caretColor: 'transparent',
    pointerEvents: 'none',
    '& label': {
      fontSize: '13px',
    },
    '& input': {
      color: theme.palette.text.secondary,
    },
  },
  emailTextField: {
    marginBottom: '30px',
  },
  requestDynamicLink: {
    marginLeft: '15px',
    fontSize: '13px',
    lineHeight: '19.5px',
    color: theme.palette.text.secondary,
    cursor: 'pointer',
  },
  haveAccountWrapper: {
    display: 'flex',
    marginTop: '20px',
    color: theme.palette.text.secondary,
    '& p': {
      fontSize: '13px',
    },
  },
  login: {
    marginLeft: '5px',
    color: theme.palette.primary.main,
    fontWeight: 700,
    cursor: 'pointer',
  },
}));

const View: React.FC<ViewProps> = ({
  isLoading,
  email,
  clinic,
  login,
  requestDynamicLink,
}) => {
  const classes = useStyles();

  if (isLoading) {
    return <Loader />;
  }

  return (
    <OnboardingWrapper>
      <div className={classes.container}>
        <div className={classes.textFieldsWrapper}>
          <Typography className={classes.header}>Email Sent!</Typography>
          <Typography className={classes.confirmationParagraph}>
            We’ve sent your request for a link you can use to log in. If
            approved we will send you a link to your email address.
          </Typography>
          <TextField
            className={`${classes.textField} ${classes.emailTextField}`}
            id="email"
            name="email"
            label="Email"
            type="email"
            variant="outlined"
            value={email}
          />
          <TextField
            className={classes.textField}
            id="clinicName"
            name="clinicName"
            label="clinicName"
            type="clinicName"
            variant="outlined"
            value={clinic.name}
          />
          <Typography
            className={classes.requestDynamicLink}
            onClick={() => requestDynamicLink()}>
            Resend email
          </Typography>
          <div className={classes.haveAccountWrapper}>
            <Typography>Already have an account?</Typography>
            <Typography className={classes.login} onClick={login}>
              Log in
            </Typography>
          </div>
        </div>
      </div>
    </OnboardingWrapper>
  );
};

export default View;
